<template>
  <div id="pageRoot">

    <span class="normalTheme pageInstruction" style="left: 90px; top: 20px;">
      <p>Marca la palabra repetida.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 90px; top: 60px;">
      <p>Escríbela debajo de la lista y dibuja lo que representa.</p>
    </span>

    <div style="position:absolute; top: 120px; left: 90px">
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 0px;"
        >RANA
        <input type="checkbox" name="maraca"
        disabled="true"
        checked="true" 
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 53px;"
        >RATÓN
        <input type="checkbox" name="maraca"
        disabled="true"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 106px;"
        >RANA
        <input type="checkbox" name="maraca"
        disabled="true"
        checked
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 159px;"
        >RATA
        <input type="checkbox" name="maraca"
        disabled="true"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01"
      defaultText="RANA"
      disabled
    />

    <div style="position:absolute; top: 120px; left: 405px">
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 0px;"
        >LOBO
        <input type="checkbox" name="maraca"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 53px;"
        >LODO
        <input type="checkbox" name="maraca"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 106px;"
        >LOMO
        <input type="checkbox" name="maraca"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 159px;"
        >LOBO
        <input type="checkbox" name="maraca"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <div style="position:absolute; top: 120px; left: 720px">
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 0px;"
        >GORRIÓN
        <input type="checkbox" name="maraca"
        ref="c1" 
        v-on:change="saveOption('radios', 'c1')" 
        :onload="loadOption('radios', 'c1')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 53px;"
        >GORRIÓN
        <input type="checkbox" name="maraca"
        ref="c2" 
        v-on:change="saveOption('radios', 'c2')" 
        :onload="loadOption('radios', 'c2')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 106px;"
        >GOTA
        <input type="checkbox" name="maraca"
        ref="c3" 
        v-on:change="saveOption('radios', 'c3')" 
        :onload="loadOption('radios', 'c3')"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; top: 159px;"
        >GORRA
        <input type="checkbox" name="maraca"
        ref="c4" 
        v-on:change="saveOption('radios', 'c4')" 
        :onload="loadOption('radios', 'c4')"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <uploaded-image
      class="image01 pageElement picture-slot"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
    ></uploaded-image>
    <uploaded-image
      class="image03 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
    ></uploaded-image>

    <div id="button01" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="0"
        :disabled="true"
      ></image-upload>
    </div>
    <div id="button02" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
      ></image-upload>
    </div>
    <div id="button03" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="3"
      ></image-upload>
    </div>
    <img
    style="width: 160px; top: 480px; left: 120px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p18/rana.svg"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 190px;
  height: 35px;
  left: 97px;
  top: 350px;
  z-index: 5;
}
#inputField02 {
  position: absolute;
  width: 190px;
  height: 35px;
  left: 415px;
  top: 350px;
  z-index: 5;
}
#inputField03 {
  position: absolute;
  width: 190px;
  height: 35px;
  left: 731px;
  top: 350px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 238px;
  height: 308px;
  left: 84px;
  top: 387px;
}
.image02 {
  position: absolute;
  width: 238px;
  height: 308px;
  left: 402px;
  top: 387px;
}
.image03 {
  position: absolute;
  width: 238px;
  height: 308px;
  left: 718px;
  top: 387px;
}

#button01 {
  width: 216px;
  height: 77px;
  left: 105px;
  top: 663px; 
  
}
#button02 {
  width: 216px;
  height: 77px;
  left: 421px;
  top: 663px; 
}
#button03 {
  width: 216px;
  height: 77px;
  left: 736px;
  top: 663px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>